import React from 'react';
import emptyStateIcon from '../assets/images/emptyState.svg';
import { svgToURL } from '../utils/svg';
import styles from '../styles.module.css';

const EmptyState: React.FC<{
  shouldShowEmptyState: boolean;
  isEmpty?: boolean;
}> = ({ shouldShowEmptyState, isEmpty }) => {
  return (
    <div
      style={{
        display: shouldShowEmptyState && isEmpty ? 'flex' : 'none',
      }}
      className={styles.whiteboardEmptyState}
    >
      <img src={svgToURL(emptyStateIcon)} />
      <p>Double-click to edit</p>
    </div>
  );
};

export default EmptyState;
